import React, { useState } from "react";
import { useGetSalesRepTickets } from "../../../hooks/SalesRep/useGetSalesRepTickets";
import { useGetSalesRepFilters } from "../../../hooks/SalesRep/useGetSalesRepFilters";
import TableView from "../../../components/TableView/TableView";
import { useNavigate, useLocation } from "react-router-dom";

const columns = ['CLIENTE', 'PLANTA', 'SERVICIO', 'ESTADO', 'CLAVE DE TICKET'];

const SalesRepHistory = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // State for filters and pagination
    const [filters, setFilters] = useState({});
    const { tickets, totalPages, isLoading, page, setPage } = useGetSalesRepTickets({ filters });
    const { clients, services, states } = useGetSalesRepFilters();

    const handleAddTicket = () => {
        const pathArray = location.pathname.split('/');
        pathArray[pathArray.length - 1] = 'tickets';
        const newPath = pathArray.join('/');
        navigate(newPath);
    };

    return (
        <TableView
            title="TICKETS"
            columns={columns}
            filters={filters}
            tickets={tickets}
            totalPages={totalPages}
            isLoading={isLoading}
            page={page}
            clients={clients}
            services={services}
            states={states}
            setFilters={setFilters}
            setPage={setPage}
            disableAddButton={false}
            handleAdd={handleAddTicket}
        />
    );
};

export default SalesRepHistory;
